@let apartmentWithApplicationData = apartmentWithApplicationInfo();
@let user = user$ | async;

@if (apartmentWithApplicationData && user) {
  @let application = apartmentWithApplicationData.application;
  <homey-apartment-detail-page-content
    [apartment]="apartmentWithApplicationData"
    [application]="apartmentWithApplicationData.application"
    [householdSize]="user.householdInfo.size"
    [relevantApartmentsInput]="{ type: 'user', user: user }"
  >
    @if (application && application.status !== 'selected' && application.status !== 'not-selected') {
      <div trackingBanner class="flex items-center gap-2 text-base font-medium" style="color: #065f46">
        <span class="relative flex h-2.5 w-2.5 items-center justify-center">
          <span class="absolute inline-flex h-full w-full rounded-full opacity-45 animate-ping"
                [style.animation-duration]="'1.6s'"
                [style.transform]="'scale(1.05)'"
                style="background-color: #86efac"></span>
          <span class="relative inline-flex h-2 w-2 rounded-full"
                style="background-color: #10b981; box-shadow: 0 0 0 1px rgba(16, 185, 129, 0.4)"></span>
        </span>
        <span>Tracking application, no action required</span>
      </div>
    }

    @if (application) {
      <homey-lottery-timeline [lottery]="apartmentWithApplicationData" [application]="application"/>

      @if (application.createdAt && application.createdAt < yesterday && application.status === 'not-synced') {
        <p class="text-yellow-500 mt-4 -mx-4 text-sm">
          <i class="pi pi-exclamation-triangle"></i>
          {{ 'apartment.application.slowProcessing' | transloco }}
          <br />
          {{ 'apartment.application.pleaseWaitOr' | transloco }}
          <a class="underline cursor-pointer" [routerLink]="'/support'">
            {{ 'common.cta.contactSupport' | transloco }}
          </a>
        </p>
      }
    } @else if (apartmentWithApplicationData.status === 'closed') {
      <p>{{ 'common.status.lotteryClosed' | transloco }}</p>
    } @else {
      @if ((apartmentWithApplicationData | estimatedEligibility)()) {
        @if (user.status === 'active') {
          <div class="flex flex-row justify-between items-center">
            <p>{{ 'common.status.eligible' | transloco }}</p>
            <homey-submit-button
              class="font-normal flex-shrink-0"
              [submitButtonLabel]="'common.cta.apply' | transloco"
              size="small"
              [submitFunction]="apply"
            />
          </div>
        } @else {
          <p>{{ 'common.cta.completeProfileToApply' | transloco }}</p>
        }
      } @else {
        @if (user.status === 'active') {
          <p>{{ 'common.status.ineligible' | transloco }}</p>
        } @else {
          <p>{{ 'common.status.likelyIneligible' | transloco }}</p>
        }
      }
    }

    <ng-container apartmentUnits>
      @let eligibleResult = apartmentWithApplicationData | relevantAdvertisements: {type: 'user', user: user};

      @if (eligibleResult.status === 'ineligible') {
        <homey-apartment-detail-info-item
          icon="pi-warehouse"
          [title]="'apartment.ineligibility.title' | transloco"
        >
          <p>
            @if (eligibleResult.reason === 'household-size-too-high') {
              {{ 'apartment.ineligibility.householdSizeTooHigh' | transloco : {
              max: (apartmentWithApplicationData.unitTypes | maxHouseholdSize)
            } }}
            } @else if (eligibleResult.reason === 'income-too-high') {
              {{ 'apartment.ineligibility.incomeTooHigh' | transloco }}
              <!--
              {{ 'apartment.ineligibility.maxIncome' | transloco : {
                value: (apartmentWithApplicationData.unitTypes
                        | relevantForHouseholdSize: user.householdInfo.size
                        | maxHouseholdIncome | dollar)
              } }}
              -->
            } @else if (eligibleResult.reason === 'income-too-low') {
              {{ 'apartment.ineligibility.incomeTooLow' | transloco }}
              <!--
              {{ 'apartment.ineligibility.minIncome' | transloco : {
                value: (apartmentWithApplicationData.unitTypes
                        | relevantForHouseholdSize: user.householdInfo.size
                        | minHouseholdIncome | dollar)
              } }}
              TODO
              -->
            } @else if (eligibleResult.reason === 'household-size-too-low') {
              {{ 'apartment.ineligibility.householdSizeTooLow' | transloco : {
              min: (apartmentWithApplicationData.unitTypes | minHouseholdSize)
            } }}
            } @else if (eligibleResult.reason === 'senior-ineligible') {
              {{ 'apartment.ineligibility.seniorIneligible' | transloco }}
            }
          </p>
        </homey-apartment-detail-info-item>
      } @else {
        @if (apartmentWithApplicationData.type === 'regular') {
          @let eligibleResult = apartmentWithApplicationData | relevantAdvertisements: {type: 'user', user: user};
          @if (eligibleResult.status === 'eligible') {
            <homey-apartment-detail-info-item
              icon="pi-warehouse"
              title="Eligible units">
              <homey-regular-eligible-units [eligibleUnits]="eligibleResult.advertisements" />
            </homey-apartment-detail-info-item>
          }
        }
        @else {
          @let eligibleResult = apartmentWithApplicationData | relevantAdvertisements: {type: 'user', user: user};
          @if (eligibleResult.status === 'eligible') {
            <homey-apartment-detail-info-item
              icon="pi-warehouse"
              title="Eligible units">
              <homey-senior-eligible-units [eligibleUnits]="eligibleResult.apartments" />
            </homey-apartment-detail-info-item>
          }
        }
      }
    </ng-container>
  </homey-apartment-detail-page-content>


  @if (application && (application.status === 'applied' || application.status === 'pending-selection' || application.status === 'not-synced')) {
    <div class="pt-8">
    @if (application.manuallyWithdrawn) {
      <p class="text-surface-500">
        {{ 'apartment.application.withdrawnNotice' | transloco }}
      </p>
    } @else {
      <p-button
        severity="danger"
        size="small"
        (onClick)="onWithdrawClick()"
        [label]="'common.cta.withdrawApplication' | transloco"
      />
    }
      </div>
  }
}
<p-confirm-dialog key="lottery-confirm"/>
